const escape = document.createElement('textarea');

export const escapeHTML = (html) => {
	escape.textContent = html;
	return escape.innerHTML;
};

export default escapeHTML;
